export const cleanSrcForJPG = (url) => {
  const sufix = '_opt';

  if (!url || typeof url !== 'string') {
    return 'default.jpg';
  }

  // 1. Encontrar la posición del último '/' para separar el path del filename.
  const lastSlashIndex = url.lastIndexOf('/');

  let path = '';
  let fileNameWithExtension = url;

  if (lastSlashIndex !== -1) {
    // Si hay '/', separa el path y el filename.
    path = url.substring(0, lastSlashIndex + 1); // Incluye el último '/'
    fileNameWithExtension = url.substring(lastSlashIndex + 1);
  }

  // 2. Aislar el nombre base (sin extensión) del filename.
  const lastDotIndex = fileNameWithExtension.lastIndexOf('.');
  let baseName;

  if (lastDotIndex !== -1) {
    baseName = fileNameWithExtension.substring(0, lastDotIndex);
  } else {
    baseName = fileNameWithExtension;
  }

  // 3. Aplicar las transformaciones SOLO al nombre base.

  // A. Convertir a minúsculas
  let cleanedBaseName = baseName.toLowerCase();

  // B. Reemplazar todos los guiones (-) por guiones bajos (_).
  cleanedBaseName = cleanedBaseName.replace(/-/g, '_');

  // C. Reemplazar todos los espacios en blanco ( ) por guiones bajos (_).
  cleanedBaseName = cleanedBaseName.replace(/ /g, '_');

  // 4. Reconstruir la URL final con el path, el nombre limpio, el sufijo y la extensión .jpg.
  return `${path}${cleanedBaseName}${sufix}.jpg`;
};
